import React, {useState} from 'react';

export default function CollapsibleTaskDiagram({children}) {
 const [expanded,setExpanded]=useState(true);
 return <details open={expanded} onToggle={event=>setExpanded(event.currentTarget.open)} style={{margin:'16px 0'}}>
  <summary style={{cursor:'pointer',padding:'8px 0',width:'fit-content'}}>Rysunek</summary>
  {expanded&&children}
 </details>;
}
